// extracted by mini-css-extract-plugin
export default {"reactionContainer":"Reaction_reactionContainer__pH90U","icon":"Reaction_icon__-ktc7","iconOwn":"Reaction_iconOwn__Xrvcw","number":"Reaction_number__K8qDT"};